import { render, staticRenderFns } from "./FormView.vue?vue&type=template&id=05822574"
import script from "./FormView.vue?vue&type=script&lang=ts"
export * from "./FormView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports